import React, { useState, useEffect, useMemo } from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function AdvertisementProducts() {
 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ FETCH DATA
 const fetchData = async () => { 
  try {
    setLoading(true);

    const res = await productService.getAdvertisedProducts();

    const productsArray = Array.isArray(res.data)
      ? res.data
      : res.data?.data || [];

    setProducts(productsArray);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchData();
  }, []);



const handleDeleteAdvertisement = async (item) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  });

  // User clicked Cancel
  if (!result.isConfirmed) {
    return;
  }

  try {
    await productService.updateAdvertisementStatus(
      item.id,
      0
    );

    await fetchData();

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "Advertisement deleted successfully.",
      confirmButtonColor: "#FB6C22",
    });

  } catch (err) {
    console.error(err);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to delete advertisement.",
    });
  }
};



 const tableData = useMemo(() => {
  return products.map((item, index) => ({
    ...item,
    sl: index + 1,
  }));
}, [products]);

 return (
  <DashboardWrapper>
    <div
      className="container-fluid"
      style={{
        marginTop: "10px",
        paddingTop: "0",
        paddingBottom: "0",
      }}
    >
      {/* TOP ROW */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          marginBottom: "8px",
          padding: "0 4px",
        }}
      >
        {/* Advertisement Products - LEFT */}
        <h4
          className="mb-0"
          style={{
            fontSize: "20px",
            fontWeight: "500",
            color: "#374151",
          }}
        >
          Advertisement Products
        </h4>

        {/* Breadcrumb - RIGHT */}
        <div style={{ margin: 0 }}>
          <Breadcrumb />
        </div>
      </div>

      {/* TABLE CARD */}
      <div
        className="card shadow"
        style={{
          marginTop: "0",
          marginBottom: "10px",
        }}
      >
        {/* CARD HEADER */}
        <div
          className="card-header d-flex justify-content-start align-items-center"
          style={{
            padding: "8px 16px",
            minHeight: "50px",
          }}
        >
          {/* Create Advertisement - LEFT */}
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              navigate("/admin/create-advertisement-section")
            }
            style={{
              padding: "7px 16px",
              fontSize: "14px",
            }}
          >
            Create Advertisement
          </button>
        </div>

        {/* TABLE BODY */}
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minHeight: "150px",
              padding: "20px",
            }}
          >
            <div
              className="spinner-border text-primary"
              role="status"
            >
              <span className="visually-hidden">
                Loading...
              </span>
            </div>
          </div>
        ) : (
          <div
            className="card-body"
            style={{
              padding: "8px 16px 10px",
            }}
          >
            <CrudTable
              data={tableData}
              columns={[
                "sl",
                "thumb_image",
                "name",
                "price",
                "offer_price",
                "offer_start_date",
                "offer_end_date",
                "qty",
                "is_advertised",
              ]}
              onDeleteAdvertisement={handleDeleteAdvertisement}

            />
          </div>
        )}
      </div>
    </div>
  </DashboardWrapper>
);
}